/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

/**
 * @description Schedule dates for a projected item.
 */
export const projectedScheduleSchema = z
  .object({
    forecastedFinishDateTime: z.iso.datetime().nullish(),
    forecastedStartDateTime: z.iso.datetime().nullish(),
    latestFinishDateTime: z.iso.datetime().nullish(),
  })
  .describe('Schedule dates for a projected item.');
